module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/lawson_haagendazs-3565daf45b34470e9b9971970a0b7c01.jpg";